module.exports = __webpack_public_path__ + "static/media/asset_3.efdacede.png";